type LenisLike = { stop?: () => void; start?: () => void };

/**
 * FilterSidebarController — 목록 필터 사이드바의 모바일 하단 시트 토글.
 *
 * 데스크톱(lg↑): SCSS 로 sticky 사이드바, 트리거 버튼 숨김 → 이 컨트롤러는 사실상 무동작.
 * 모바일(lg↓): `[data-filter-trigger]` 클릭 → `[data-filter-sidebar]` 에 .is-open 부여(하단 시트).
 *   backdrop/닫기버튼(`[data-filter-close]`)·Escape 로 닫힘. 열려 있는 동안 Lenis 정지(#12 정신).
 * 여러 인스턴스 지원(페이지당 1개가 보통이나 안전하게 전부 바인딩).
 */
export class FilterSidebarController {
    static init(): void {
        const triggers = document.querySelectorAll<HTMLElement>("[data-filter-trigger]");
        if (triggers.length === 0) return;

        triggers.forEach((trigger) => {
            const layout = trigger.parentElement;
            const sidebar = layout?.querySelector<HTMLElement>("[data-filter-sidebar]")
                ?? document.querySelector<HTMLElement>("[data-filter-sidebar]");
            if (!sidebar) return;

            const open = (): void => this.set(trigger, sidebar, true);
            const close = (): void => this.set(trigger, sidebar, false);

            trigger.addEventListener("click", open);
            sidebar.querySelectorAll<HTMLElement>("[data-filter-close]").forEach((el) => {
                el.addEventListener("click", close);
            });
            document.addEventListener("keydown", (e) => {
                if (e.key === "Escape" && sidebar.classList.contains("is-open")) close();
            });
            window.addEventListener("resize", () => {
                if (window.innerWidth > 1024 && sidebar.classList.contains("is-open")) close();
            });
        });
    }

    private static set(trigger: HTMLElement, sidebar: HTMLElement, open: boolean): void {
        sidebar.classList.toggle("is-open", open);
        trigger.setAttribute("aria-expanded", open ? "true" : "false");

        const backdrop = sidebar.querySelector<HTMLElement>(".ui-filter-sidebar__backdrop");
        if (backdrop) backdrop.hidden = !open;

        const lenis = (window as unknown as { lenis?: LenisLike }).lenis;
        if (open) lenis?.stop?.();
        else lenis?.start?.();
    }
}
